import React, { useEffect, useState } from 'react';
import { Tabs } from 'antd';
import {
  arrayOf, func, shape, string,
} from 'prop-types';
import CustomScrollbars from '../../../util/CustomScrollbars';
import SearchBox from '../../../components/SearchBox';
import TicketCell from './ticketCell';

const SupportRequest = ({ supports, onSelectTicket, selectedTicketId = null }) => {
  const [search, setSearch] = useState('');
  const [tickets, setTickets] = useState(supports);
  const handleSearch = (value) => {
    if (value === '') {
      setTickets(supports);
      return setSearch(value);
    }
    const match = supports.filter(({ user: { firstName, lastName } }) => {
      const name = `${firstName} ${lastName}`.toLowerCase();
      return name.includes(value.toLowerCase());
    });
    setSearch(value);
    setTickets(match);
  };

  useEffect(() => {
    setTickets(supports);
  }, [supports]);
  return (
    <div className="gx-chat-sidenav-main">
      <div className="gx-chat-sidenav-header">
        <div className="gx-chat-search-wrapper">
          <SearchBox
            styleName="gx-chat-search-bar gx-lt-icon-search-bar-lg"
            placeholder="Search supports"
            onChange={(e) => handleSearch(e.target.value)}
            value={search}
          />
        </div>
      </div>
      <div className="gx-chat-sidenav-content">
        {/* An `items` array rather than Tabs.TabPane children, which antd
            4.23 deprecated. The second tab, for closed tickets, was already
            commented out before this change and is left out rather than
            carried forward as dead JSX. */}
        <Tabs
          className="gx-tabs-half"
          defaultActiveKey="1"
          items={[{
            key: '1',
            label: 'Support Tickets',
            children: (
              <CustomScrollbars className="gx-chat-sidenav-scroll-tab-1">
                {supports.length === 0
                  ? <div className="gx-p-5">No tickets yet</div>
                  : (
                    <div className="gx-chat-user">
                      {tickets.map((support) => (
                        <TicketCell
                          key={support.id}
                          ticket={support}
                          selectedTicketId={selectedTicketId}
                          onSelectTicket={onSelectTicket}
                        />
                      ))}
                    </div>
                  )}
              </CustomScrollbars>
            ),
          }]}
        />
      </div>
    </div>
  );
};

SupportRequest.propTypes = {
  supports: arrayOf(shape({})).isRequired,
  onSelectTicket: func.isRequired,
  selectedTicketId: string,
};

export default SupportRequest;
